export default function ({ store, from, route }) {
    if (process.client) {
        store.dispatch("routing/addPreviousRoute", {
            from,
            to: route,
        })
    }
}
